<script setup lang="ts">
import type { CmsElementCategoryBoxes } from "~/composables/useCustom";
const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);

const props = defineProps<{
  content: CmsElementCategoryBoxes;
}>();

const categoryData = props.content?.data || {};
const { button } = categoryData;

</script>

<template v-if="categoryData">
  <div class="unveil-kisag md:bg-c-light-grey px-4">
    <div class="container mx-auto relative py-0 sm:py-20">
      <h3
        class="h3-font mb-8 text-dark-bg block md:hidden"
        v-html="categoryData.headlineText"
      ></h3>
      <div class="nowrap md:wrap flex md:grid kitchen-selection overflow-x-scroll md:overflow-visible gap-0 md:gap-6 -mx-[18px] md:mx-0">
        <div class="cust-col-span-1 min-h-[auto] md:min-h-[330px] hidden md:block">
          <div class="inner-wrap flex justify-between">
            <div class="title p-2">
              <h3
                class="h3-font mb-3 text-dark-bg"
                v-html="categoryData.headlineText"
              ></h3>
              <div
                class="para font-normal mb-9 text-dark-bg"
                v-if="categoryData.mainText"
                v-html="categoryData.mainText"
              ></div>
              <SharedButton
                v-if="button"
                :button="button"
                class="btn-default btn-black-bg px-16"
              >
              </SharedButton>
            </div>
          </div>
        </div>

        <template v-for="(box, key) in categoryData.Boxen">
          <div
            v-if="box.boxImage && box.boxButton"
            class="cust-col-span-1 min-h-[220px] md:min-h-[330px] min-w-[75%] md:min-width-full pl-[20px] md:px-0"
            :class="{ 'pr-[20px] md:pr-0': key === categoryData.Boxen.length - 1 }"
          >
            <div
              class="inner-wrap flex justify-between relative h-full rounded-lg truncate"
            >
              <div class="w-full h-full">
                <figure class="h-full">
                  <NuxtImg
                    v-if="box.boxImage?.media"
                    format="webp"
                    :src="box.boxImage?.media?.url"
                    :height="box.boxImage?.media?.metaData?.height"
                    :width="box.boxImage?.media?.metaData?.width"
                    class="w-full h-full object-cover object-left"
                    :alt="box.boxImage?.media?.alt"
                    loading="lazy"
                  />
                </figure>
              </div>
              <div class="content absolute bottom-4 left-4 w-fit">
                <SharedButton
                  v-if="box.boxButton"
                  :button="box.boxButton"
                  class="btn-default btn-w-icon btn-white-bg"
                  :isInnerHtml=true
                >
                </SharedButton>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped>
img {
  /* gradient loader background with animation */
  background: linear-gradient(to right, #f4f3f3, #f1f1f1);
  background-size: 200% 100%;
  animation: gradient-animation 3s ease-in-out infinite;
}

@keyframes gradient-animation {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}
</style>
